import { IState } from './../../shared/store/root.reducer';
import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  footerCssClass: string;
  subscriptions: Subscription[] = [];
  versionNumber = 'DEVELOPMENT';
  today: number = Date.now();

  constructor(
    private store: Store<IState>,
  ) { }

  ngOnInit() {
    this.subscriptions.push(this.store.pipe(select((store: IState) => store.fullScreen))
      .subscribe(fullScreenState => {
        this.footerCssClass = fullScreenState.footerCssClass;
    }));
    this.subscriptions.push(this.store.pipe(select((store: IState) => store.app.version))
      .subscribe(version => {
        this.versionNumber = version;
    }));
  }

  ngOnDestroy() {
    this.subscriptions.map(subscription => {
      subscription.unsubscribe();
    });
  }

}
